import { ITEM_TYPES } from './config.js';

export const ACTIVITY_TYPES = Object.freeze({
    PHONE_CALL: 'phoneCall',
    CHECK_IN: 'checkIn',
    VIDEO_CHECK_IN: 'videoCheckIn',
    FAST_CHECK_IN: 'fastCheckIn',
    EMAIL: 'email',
    VIDEO_CALL: 'videoCall',
    WHATSAPP: 'whatsapp',
});

/** @type {ReadonlyArray<{ activityType: string, className: string, labelKey: string, defaultLabel: string }>} */
export const ACTIVITY_VARIANTS = Object.freeze([
    {
        activityType: ACTIVITY_TYPES.PHONE_CALL,
        className: 'phone',
        labelKey: 'activities.phoneCall',
        defaultLabel: 'Llamadas telefónicas',
    },
    {
        activityType: ACTIVITY_TYPES.CHECK_IN,
        className: 'checkin',
        labelKey: 'activities.checkIn',
        defaultLabel: 'Check-in',
    },
    {
        activityType: ACTIVITY_TYPES.VIDEO_CHECK_IN,
        className: 'video-checkin',
        labelKey: 'activities.videoCheckIn',
        defaultLabel: 'Video Check-in',
    },
    {
        activityType: ACTIVITY_TYPES.FAST_CHECK_IN,
        className: 'fast-checkin',
        labelKey: 'activities.fastCheckIn',
        defaultLabel: 'Fast Check-in',
    },
    {
        activityType: ACTIVITY_TYPES.EMAIL,
        className: 'email',
        labelKey: 'activities.email',
        defaultLabel: 'Email',
    },
    {
        activityType: ACTIVITY_TYPES.VIDEO_CALL,
        className: 'video-call',
        labelKey: 'activities.videoCall',
        defaultLabel: 'Video llamada',
    },
    {
        activityType: ACTIVITY_TYPES.WHATSAPP,
        className: 'whatsapp',
        labelKey: 'activities.whatsapp',
        defaultLabel: 'Whatsapp',
    },
]);

const ACTIVITY_META_BY_TYPE = Object.freeze(
    Object.fromEntries(ACTIVITY_VARIANTS.map((variant) => [variant.activityType, variant])),
);

export function isActivityItem(item) {
    return (
        item?.type === ITEM_TYPES.ACTIVITY_ITEM ||
        item?.type === 'activityItem' ||
        item?.variant === 'activity'
    );
}

export function resolveActivityType(item) {
    if (item.activityType) return item.activityType;

    const label = String(item.label || '').toLowerCase();

    if (label.includes('llamada') && !label.includes('video')) return ACTIVITY_TYPES.PHONE_CALL;
    if (label.includes('video check')) return ACTIVITY_TYPES.VIDEO_CHECK_IN;
    if (label.includes('fast')) return ACTIVITY_TYPES.FAST_CHECK_IN;
    if (label.includes('check')) return ACTIVITY_TYPES.CHECK_IN;
    if (label.includes('video llamada')) return ACTIVITY_TYPES.VIDEO_CALL;
    if (label.includes('whatsapp')) return ACTIVITY_TYPES.WHATSAPP;
    if (label.includes('email') || label.includes('correo') || label.includes('mail')) {
        return ACTIVITY_TYPES.EMAIL;
    }

    return ACTIVITY_TYPES.EMAIL;
}

export function getActivityMeta(item) {
    const activityType = resolveActivityType(item);
    return ACTIVITY_META_BY_TYPE[activityType] || ACTIVITY_META_BY_TYPE[ACTIVITY_TYPES.EMAIL];
}

export function getActivityLabel(item, t) {
    if (typeof t === 'function' && item.labelKey) {
        return t(item.labelKey, item.label || getActivityMeta(item).defaultLabel);
    }

    return item.label || getActivityMeta(item).defaultLabel;
}
